// src/stores/blogStore.ts
import { create } from 'zustand';
import type { BlogPost, BlogFilters } from '../types';

interface BlogState {
  posts: BlogPost[];
  selectedPost: BlogPost | null;
  filters: BlogFilters;
  loading: boolean;
  error: string | null;
  // Actions
  setPosts: (posts: BlogPost[]) => void;
  setSelectedPost: (post: BlogPost | null) => void;
  closeModal: () => void;
  setFilters: (filters: BlogFilters) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const useBlogStore = create<BlogState>((set) => ({
  posts: [],
  selectedPost: null,
  filters: { tags: [], search: '' },
  loading: false,
  error: null,
  
  setPosts: (posts) => set({
    posts: posts.map(post => ({
      ...post,
      visualization: post.visualization,
    }))
  }),
  setSelectedPost: (post) => set({
    selectedPost: post ? {
      ...post,
      visualization: post.visualization,
    } : null
  }),
  closeModal: () => set({ selectedPost: null }),
  setFilters: (filters) => set({ filters }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error })
}));